import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react"
import { Card, CardBody, Col, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import FormInformation from "./form-information"
import FormTrousers from "./form-trousers"
import FormJackets from "./form-jackets"
import FormPayment from "./form-payments"
import moment from "moment"
import SButton from "components/Common/Button"
import Canvas from "./Canvas"
import CompanyAPI from "helpers/company_backend_helper"

const Repair = forwardRef(
  (
    { form, setForm, edit, setCanvas, trigger, activeTab, setActiveTab },
    ref
  ) => {
    const [customerOptions, setCustomerOptions] = useState([])
    const [customerId, setCustomerId] = useState({ label: "", value: "" })
    const getCanvasRef = useRef()
    useEffect(() => {
      if (form?.customerId?.value) {
        setCustomerId(form?.customerId)
      }
    }, [form.customerId])

    useImperativeHandle(ref, () => ({
      async saveCanvas() {
        const getCanvas = await getCanvasRef.current.saveCanvas()

        return getCanvas
      },
    }))

    const handleChangeSelect = async (value, name) => {
      let temp = { ...form }
      if (!value) {
        setForm({ ...temp, [name]: "" })
        return
      }
      if (name === "storeId") {
        temp.customerId = 0
        const res = await CompanyAPI.getList({ branchId: value.value })
        const options = res.data.map(val => {
          return { label: `${val.customerName}`, value: val.id }
        })
        setCustomerOptions(options)
      }
      if (name === "customerId") {
        setCustomerId(value)
        setForm({ ...temp, [name]: value.value })
      } else {
        setForm({ ...temp, [name]: value })
      }
    }

    const handleSelectDate = (value, name) => {
      setForm({ ...form, [name]: moment(value).format("yyyy-MM-DD") })
    }

    const handleChangeInput = event => {
      setForm({ ...form, [event.target.name]: event?.target?.value })
    }

    const handleCheckboxInput = event => {
      const { name, checked } = event.target
      setForm({ ...form, [name]: checked })
    }

    const handleChangeCurrency = (value, name) => {
      setForm({ ...form, [name]: value })
    }

    return (
      <>
        <Row>
          <div className="d-flex my-3">
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${!activeTab ? "button-active" : "button"}`}
              onClick={() => setActiveTab(0)}
            >
              受注新規追加
            </SButton>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${activeTab ? "button-active" : "button"}`}
              onClick={() => setActiveTab(1)}
            >
              手書きノート
            </SButton>
          </div>
        </Row>

        <Card>
          <CardBody>
            <Row>
              {activeTab === 0 ? (
                <Col sm={12}>
                  <Card>
                    <CardBody>
                      <FormInformation
                        form={form}
                        handleChangeInput={handleChangeInput}
                        handleChangeSelect={handleChangeSelect}
                        handleCheckboxInput={handleCheckboxInput}
                        handleSelectDate={handleSelectDate}
                        customerOptions={customerOptions}
                        setForm={setForm}
                        customerId={customerId}
                        handleChangeCurrency={handleChangeCurrency}
                      />
                      <FormTrousers
                        form={form}
                        handleChangeInput={handleChangeInput}
                        handleChangeSelect={handleChangeSelect}
                        handleSelectDate={handleSelectDate}
                      />
                      <Row>
                        <Col>
                          <FormJackets
                            form={form}
                            handleChangeInput={handleChangeInput}
                            handleChangeSelect={handleChangeSelect}
                            handleSelectDate={handleSelectDate}
                          />
                        </Col>
                      </Row>
                      {edit && (
                        <Row>
                          <Col sm={5}>
                            <FormPayment
                              setForm={setForm}
                              form={form}
                              handleChangeInput={handleChangeInput}
                              handleChangeSelect={handleChangeSelect}
                              handleSelectDate={handleSelectDate}
                            />
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              ) : (
                <Canvas
                  setCanvas={e => setCanvas(e)}
                  trigger={trigger}
                  ref={ref}
                  data={form}
                  edit={edit}
                />
              )}
            </Row>
          </CardBody>
        </Card>
      </>
    )
  }
)

export default Repair
